import React, { useEffect, useState } from 'react';
const INITIAL_COPIES = 985;
const MIN_COPIES = 30;
const STORAGE_KEY = 'bttf_copies_available';
export const CopiesAvailableCounter = () => {
  const [copiesAvailable, setCopiesAvailable] = useState(() => {
    if (typeof window === 'undefined') return INITIAL_COPIES;
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? parseInt(stored, 10) : INITIAL_COPIES;
  });
  useEffect(() => {
    // Initialize localStorage if not set
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      localStorage.setItem(STORAGE_KEY, INITIAL_COPIES.toString());
    }
    const decrementCopies = () => {
      setCopiesAvailable(prev => {
        // Don't go below MIN_COPIES to maintain urgency
        if (prev <= MIN_COPIES) return prev;
        // Decrease by 1-3 copies randomly
        const decrease = Math.floor(Math.random() * 3) + 1;
        const newValue = Math.max(MIN_COPIES, prev - decrease);
        // Store in localStorage
        localStorage.setItem(STORAGE_KEY, newValue.toString());
        // Dispatch custom event for synchronization
        window.dispatchEvent(new CustomEvent('copiesUpdated', {
          detail: newValue
        }));
        return newValue;
      });
    };
    // Listen for updates from other components
    const handleCopiesUpdate = (event: CustomEvent) => {
      setCopiesAvailable(event.detail);
    };
    window.addEventListener('copiesUpdated', handleCopiesUpdate as EventListener);
    // Listen for storage changes from other tabs
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === STORAGE_KEY && e.newValue) {
        setCopiesAvailable(parseInt(e.newValue, 10));
      }
    };
    window.addEventListener('storage', handleStorageChange);
    // Random interval between 2-4 seconds
    const getRandomInterval = () => Math.floor(Math.random() * 2000) + 2000;
    let timeoutId: NodeJS.Timeout;
    const scheduleNextDecrement = () => {
      timeoutId = setTimeout(() => {
        decrementCopies();
        scheduleNextDecrement();
      }, getRandomInterval());
    };
    scheduleNextDecrement();
    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener('copiesUpdated', handleCopiesUpdate as EventListener);
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);
  return <div className="w-[90%] md:w-auto inline-flex flex-col items-center gap-2 md:gap-3 bg-gradient-to-r from-red-600 to-orange-600 text-white font-bold px-6 py-4 md:px-10 md:py-5 lg:px-12 lg:py-6 rounded-lg shadow-lg animate-pulse" data-id="element-91">
      <div className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1 md:gap-3" data-id="element-92">
        <span className="text-2xl md:text-3xl lg:text-4xl tabular-nums font-extrabold" data-id="element-93">
          LIMITED 1985 COPIES RELEASE
        </span>
      </div>
      <div className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1 md:gap-3" data-id="element-94">
        <span className="text-base md:text-xl lg:text-2xl uppercase tracking-wider" data-id="element-95">
          ONLY
        </span>
        <span className="text-4xl md:text-4xl lg:text-5xl tabular-nums transition-all duration-300 font-extrabold" data-id="element-96">
          {copiesAvailable.toLocaleString()}
        </span>
        <span className="text-base md:text-xl lg:text-2xl uppercase tracking-wider" data-id="element-97">
          LEFT
        </span>
      </div>
    </div>;
};